@if (anchor) {
  <a [id]="anchor"></a>
}
@if (attributes.headline) {
  <h2 kb-heading type="divider" [appEditorId]="editorIds?.headline">{{attributes.headline}}</h2>
}

<div class="surface" [attr.color-variant]="attributes.backgroundColor ?? 'blue'">
  @if (attributes.showLogo) {
    <div class="background-logo">
      <img src="assets/knorr-bremse-logo-white.svg" aria-hidden="true" loading="lazy">
    </div>
  }
  <div class="scroll-container kb-scrollbar">
    <div class="content">
      @for (item of attributes.items; track item) {
        <section [appEditorId]="item.editorId">
          <kb-picture
            class="image"
            [picture]="imageToPicture(item.attributes.image.attributes, squareAspectRatio).sources"
            [variants]="[{aspectRatio: squareAspectRatio}]"
            [alt]="item.attributes.image.attributes.alt"
            [appEditorId]="item.attributes.image.editorIds?.src"
            [rootColumns]="1"
          ></kb-picture>
          <h3 class="heading" [attr.color-variant]="attributes.backgroundColor ?? 'blue'" kb-heading type="bar" [appEditorId]="item.editorIds?.headline">{{ item.attributes.headline }}</h3>
          <kb-html class="text" [html]="item.attributes.copyText" [appEditorId]="item.editorIds?.copyText"></kb-html>
        </section>
      }
    </div>
  </div>
</div>
@if (createSectionButton) {
  <app-fs-button [value]="createSectionButton"></app-fs-button>
}
